import {Component, Input} from "@angular/core";
import {PossibleResolutionDialogComponent} from "./possible-resolution-dialog.component";
import {DialogService} from "../bootstrap-modal/dialog.service";

@Component({
  selector: "error-details",
  templateUrl: "./error-details.template.pug",
  providers: [
    DialogService,
  ],
})
export class ErrorDetailsComponent {
  private _errorDetails;
  showError: boolean;
  summaryArray = [];
  contextInfoArray = [];
  private isDisplayPossibleResolutionButton:boolean = true;
  toggleDetailsDisplay: boolean = false;
  errorsDetailsList = [];
  errorsTableList = [];
  transformKey(key: string): string {
    return key
      .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
      .replace(/^./, str => str.toUpperCase()); // Capitalize the first letter
  }
  objectKeys = Object.keys;
  @Input()
  set details(val) {
    this._errorDetails = val;
    this.calculateMoreDetails();
  }

  get details(): Error {
    return this._errorDetails;
  }

  @Input()
  showPossibleResolution: any = true;
  @Input()
  IsParrtiallySuccess = false;

  public openPossibleResolutionDialog(): void {
    PossibleResolutionDialogComponent.showCreateDialog(this.dialogService,this._errorDetails);
  }
  constructor(public dialogService: DialogService) {}

  calculateMoreDetails() {
    
      for (const prop of Object.keys(this._errorDetails)) {
        if (typeof this._errorDetails[prop] != "object" && this._errorDetails[prop]) {
          this.summaryArray.push({ key: this.getCamelCaseWord(prop), value: this._errorDetails[prop] });
        }
        else if (this._errorDetails[prop]) {
          if (prop == "contextInformation") {
            let details = this._errorDetails[prop];
            for (const itm of Object.keys(details)) {
              if(itm == "errorsList" ){
                this.errorsDetailsList = details[itm];
              } else if(itm == "errorsTable" ){
                this.errorsTableList = details[itm];
              }
              else if (typeof details[itm] != "object" && details[itm]) {
                this.contextInfoArray.push({ key: this.getCamelCaseWord(itm), value: details[itm].split("\\n").map(item => item.replace(/"/g, '')) });
              }
              else {
                this.contextInfoArray.push({ key: this.getCamelCaseWord(itm), value: '' });
              }
            }
          }

        }
      }
  }

  async ngOnInit() {
    if(this.showPossibleResolution == false){
      this.isDisplayPossibleResolutionButton = false;
    }else{
      this.isDisplayPossibleResolutionButton = true;
    }
  }

  getCamelCaseWord(str) {
    return str.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); })
  }
}
